export const formatCategoryName = (slug: string) => {
  if (!slug) return '';
  return slug
    .split('-')
    .filter(Boolean)
    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
    .join(' ');
};

export const formatProductTitle = (sku: string) => {
  if (!sku) return 'Producto - Comprar en Mouchi';
  const parts = sku.split('-').filter(Boolean);
  if (parts.length === 1) {
    return `${parts[0].toUpperCase()} - Comprar en Mouchi`;
  }

  const code = parts[parts.length - 1].toUpperCase();
  const nameParts = parts.slice(0, parts.length - 1).map(p => p.toUpperCase());
  const name = nameParts.join('/');
  return `${name} ${code} - Comprar en Mouchi`;
};















